import type { UnknownAction } from 'redux';

export type FrontendOutOfDateActions =
  | StartPollingFrontendOutOfDateAction
  | StopPollingFrontendOutOfDateAction
  | SetFrontendOutOfDateAction;

export interface StartPollingFrontendOutOfDateAction extends UnknownAction {
  type: 'FRONTEND_OUT_OF_DATE:START_POLLING';
}
export interface StopPollingFrontendOutOfDateAction extends UnknownAction {
  type: 'FRONTEND_OUT_OF_DATE:STOP_POLLING';
}
export interface SetFrontendOutOfDateAction extends UnknownAction {
  payload: {
    isOutOfDate: boolean;
  };
  type: 'FRONTEND_OUT_OF_DATE:SET';
}

export const startPollingFrontendOutOfDateAction = (): StartPollingFrontendOutOfDateAction => ({
  type: 'FRONTEND_OUT_OF_DATE:START_POLLING',
});

export const stopPollingFrontendOutOfDateAction = (): StopPollingFrontendOutOfDateAction => ({
  type: 'FRONTEND_OUT_OF_DATE:STOP_POLLING',
});

export const setFrontendOutOfDateAction = (isOutOfDate: boolean): SetFrontendOutOfDateAction => ({
  type: 'FRONTEND_OUT_OF_DATE:SET',
  payload: {
    isOutOfDate,
  },
});
